import { useCallback } from 'react';

import { Steps } from 'presentations/views/components/organisms/EventReservationView';

import ActiveStepFormLayout from '../components/shared/ActiveStepFormLayout';
import HostInformation, {
  Props as HostContentProps,
} from '../components/shared/HostInformation';
import SelectLocationForm, {
  Props as SelectLocationFormProps,
} from '../components/SelectLocationForm';
import SelectServiceForm, {
  Props as SelectServiceFormProps,
} from '../components/SelectServiceForm';
import GuestContactForm, {
  Props as GuestContactFormProps,
} from '../components/GuestContactForm';
import SelectPaymentMethodForm, {
  Props as SelectPaymentMethodFormProps,
} from '../components/SelectPaymentMethodForm';
import PaymentPreviewForm, {
  Props as PaymentPreviewFormProps,
} from '../components/PaymentPreviewForm';
import { isMediaMax } from 'presentations/views/styles';

type Props = {
  onClickBack: () => void;
  step: Steps;
  color: string;
  hostContent: HostContentProps;
  locationForm: SelectLocationFormProps;
  serviceForm: SelectServiceFormProps;
  guestContactForm: GuestContactFormProps;
  selectPaymentMethodForm: SelectPaymentMethodFormProps;
  paymentPreviewForm: PaymentPreviewFormProps;
  eventReservationView: React.ReactNode;
};

const stepToTitle = {
  [Steps.Date]: '',
  [Steps.DateWeekly]: '',
  [Steps.Time]: 'Time',
  [Steps.Location]: 'Location',
  [Steps.Service]: 'Service',
  [Steps.Contact]: 'Contact',
  [Steps.PaymentMethod]: 'PaymentMethod',
  [Steps.PaymentPreview]: 'PaymentPreview',
  [Steps.Complete]: '',
};

export default function Component(props: Props) {
  const onClickBack = useCallback(() => {
    if (
      [
        Steps.Time,
        Steps.Location,
        Steps.Service,
        Steps.Contact,
        Steps.PaymentMethod,
        Steps.PaymentPreview,
      ].includes(props.step)
    ) {
      props.onClickBack();
    }
  }, [props.step, props.onClickBack]);

  const isTablet = isMediaMax('tablet');
  const isUseSticky = props.step === Steps.Time && isTablet;

  let formContent = null;
  if (props.step === Steps.Time && isTablet) {
    formContent = props.eventReservationView;
  } else if (props.step === Steps.Location) {
    formContent = <SelectLocationForm {...props.locationForm} />;
  } else if (props.step === Steps.Service) {
    formContent = <SelectServiceForm {...props.serviceForm} />;
  } else if (props.step === Steps.Contact) {
    formContent = <GuestContactForm {...props.guestContactForm} />;
  } else if (props.step === Steps.PaymentMethod) {
    formContent = (
      <SelectPaymentMethodForm {...props.selectPaymentMethodForm} />
    );
  } else if (props.step === Steps.PaymentPreview) {
    formContent = <PaymentPreviewForm {...props.paymentPreviewForm} />;
  }

  return (
    <ActiveStepFormLayout
      onClickBack={onClickBack}
      backButtonColor={props.color}
      tabletTitle={stepToTitle[props.step]}
      isUseSticky={isUseSticky}
      formContent={formContent}
      hostContent={<HostInformation {...props.hostContent} />}
    />
  );
}
